import { useSelector } from 'react-redux';
import { useCallback, useState } from 'react';
import { MODAL_COMPONENTS } from '../../helpers/constant';
import clsx from 'clsx';
import { Tooltip } from '@mui/material';
import useHandleActionClick from '../../helpers/usehandleActionClick';

const ActionButtons = ({ actionIcons, selected }) => {
    const [modalAction, setModalAction] = useState(null);
    const handleCloseModal = useCallback(() => setModalAction(''), []);

    const commonModalProps = {
        onClose: handleCloseModal,
        row: selected,
        selectCurrency: true,
        isModal: true,
        preSelected: selected,
        type: modalAction,
    };

    const ModalComponent = MODAL_COMPONENTS[modalAction];

    const kycStatus = useSelector(state => state.juno.clientData)?.kyc?.status;
    const handleActionClick = useHandleActionClick(kycStatus, setModalAction);
    const clientData = useSelector(state => state.juno.clientData);
    const { readOnly } = clientData || {};

    return (
        <>
            <div className="flex gap-[6px] !text-text">
                {actionIcons?.map(iconItem => (
                    <Tooltip
                        key={iconItem?.key}
                        arrow
                        placement="top"
                        title={iconItem?.tooltip}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    textTransform: 'uppercase',
                                },
                            },
                        }}>
                        <div
                            key={iconItem?.key}
                            onClick={() => {
                                if (readOnly) return;
                                handleActionClick(iconItem?.key);
                            }}
                            className={clsx(
                                'group relative w-11 h-11 !bg-secondary rounded-lg flex justify-center items-center cursor-pointer text-inherit dark:text-white',
                                readOnly && '!cursor-not-allowed',
                            )}>
                            {iconItem?.icon}
                        </div>
                    </Tooltip>
                ))}
            </div>
            <div className="absolute">
                {modalAction ? <ModalComponent open={true} {...commonModalProps} /> : null}
            </div>
        </>
    );
};

export default ActionButtons;
